import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';

// Styles
import './CATAChoiceExplanationPanel.scss';

interface IProps {
  expandedExplanations?: string[];
  explanation?: string;
  showExplanation?: boolean;
  displayedEditId?: string;
  choices?: Annotation[];
  layoutIsHorizontal?: boolean;
  completed?: boolean;
}

const CATAChoiceExplanationPanel = ({
  expandedExplanations,
  explanation,
  showExplanation,
  layoutIsHorizontal,
  choices,
  displayedEditId,
  completed,
}: IProps) => {
  const height = showExplanation ? 'auto' : 0;
  const explanationPanelWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (layoutIsHorizontal && explanationPanelWrapperRef.current) {
      explanationPanelWrapperRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [expandedExplanations, layoutIsHorizontal]);

  if (layoutIsHorizontal && choices) {
    return (
      <div
        ref={explanationPanelWrapperRef}
        className={classNames('CATAChoiceExplanationPanel-wrapper', {
          'horizontal-layout': layoutIsHorizontal,
        })}
      >
        <div
          className={classNames('CATAChoiceExplanationPanel-static', {
            'd-none': !completed,
          })}
        >
          <div
            className={classNames('CATAChoiceExplanationPanel', {
              'horizontal-layout': layoutIsHorizontal,
            })}
          >
            {expandedExplanations?.length === 1 &&
              choices?.find((choice) => choice._id === expandedExplanations[0])?.text}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <AnimateHeight
        id="panel"
        className="CATAChoiceExplanationPanel-animation-wrapper"
        duration={300}
        height={height}
      >
        <div className="CATAChoiceExplanationPanel">{explanation}</div>
      </AnimateHeight>
    );
  }
};

export default CATAChoiceExplanationPanel;
